import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

import API from 'src/data/api';
import CustomModal from '../../custom/CustomModal';
import { extractFormValues, isNullValue, validateForm } from 'src/utils/formUtil';
import CustomTextField from 'src/components/custom/CustomTextField';
import { useSnackbar } from 'src/contexts/SnackbarContext';

const initFormState = {
  product: { value: '', required: true, error: false, errorMessage: 'Please provide product name' },
}


export const NewProductLine = ({
  openModal,
  handleCloseModal,
  handleSubmitCallback,
}) => {

  const { showSnackbar } = useSnackbar();

  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({ ...initFormState });

  useEffect(() => {

  }, [openModal]);

  const handleSubmitProduct = async () => {

    if (!validateForm(setFormData, formData)) {
      notifyError("Pleae ensure all required inputs are provided");
      return;
    }

    const { product } = extractFormValues(formData);
    let endPoint = `inventory/backoffice/create_product`
      .concat(`?product_name=${product}`)

    setSubmitted(true);
    try {
      const res = await API.post(`${endPoint}`, '');
      if (res.status === 200 || res.status === 201) {
        showSnackbar({
          message: `Successfully added new product, ${product}`,
        });
        handleSubmitCallback();
      } else {
        notifyError("An unexpected error occurred. Please try again.");
      }
    } catch (error) {
      notifyError("An unexpected error occurred. Please try again.");
    }
    setSubmitted(false);
  }

  const notifyError = (message) => {
    showSnackbar({
      message: message,
      type: "error",
    });
  }

  const handleResetAndClose = () => {
    setFormData({ ...initFormState });
    handleCloseModal();
  }

  const handleInputChange = (field, value) => {
    const _formData = {
      ...formData,
      [field]: {
        ...formData[field],
        value: value,
        error: (isNullValue(value) && formData[field]['required']),
      },
    }
    setFormData(_formData);
  };

  return (
    <>
      <CustomModal
        openModal={openModal}
        handleCloseModal={handleResetAndClose}
        modalTitle={"Add New Product"}
      >
        <CustomTextField sx={{ my: 1 }}
          multiline
          id="product"
          variant="outlined"
          name='product'
          label={`Name`}
          onChange={(e) => handleInputChange("product", e.target.value)}
          value={formData?.product.value}
          required={formData?.product.required}
          error={formData?.product.error}
          helperText={formData?.product.error && formData?.product.errorMessage}
        />

        <Box sx={{ display: 'flex', justifyContent: 'right', mt: 2 }}>
          <Button
            variant='contained'
            color="inherit"
            onClick={() => handleResetAndClose()}
            disabled={submitted}
          >
            Cancel
          </Button>
          <LoadingButton
            sx={{ ml: 2, }}
            variant="contained"
            onClick={() => handleSubmitProduct()}
            loading={submitted}
          >
            Submit
          </LoadingButton>
        </Box>
      </CustomModal>
    </>
  )
}

NewProductLine.propTypes = {

  /** Flag to toggling openning of modal */
  openModal: PropTypes.bool,

  /** Callback function when closing modal */
  handleCloseModal: PropTypes.func.isRequired,

  /** Callback function after assignment of suborder to clients */
  handleSubmitCallback: PropTypes.func.isRequired,

}